import { SxType } from "../types";

export const hideScrollbarSx = {
    "::-webkit-scrollbar ": { display: "none" },
    scrollbarWidth: "none"
};

export const gradientScrollSx: SxType = {
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
    maskImage: "linear-gradient(to right, black 85%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to right, black 85%, transparent 100%)",
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Chrome, Safari, Edge
    },
    msOverflowStyle: "none" // IE and Edge
};

export const hiddenScrollSx: SxType = {
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Chrome, Safari, Edge
    },
    msOverflowStyle: "none", // IE and Edge
    scrollBehavior: "smooth"
};

export const filterButtonRippleSx: SxType = {
    transition: "background-size 0.2s ease",
    backgroundSize: "15000%"
};

export const overflowScrollSx: SxType = {
    minHeight: 0,
    overflow: "scroll",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
